<template><!-- svgo-optimised -->
<svg  class="icon icon__plus" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.75 6.03247V19.4675" stroke="currentColor"/>
  <path d="M19.4675 12.75L6.03249 12.75" stroke="currentColor"/>
</svg>
</template>